import axios from "axios";

const development = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export default function isDev() {
    return development;
}

let backend = 'https://api.yeticlean.co.uk/'

if (isDev()) {
    backend = 'http://127.0.0.1:8000/'
}


export const Axios = axios.create({
    baseURL: backend,
    headers: {
        "Content-Type": "application/json",
    },
});

export function GetLeadByLongFormId(longFormId) {
    return new Promise((resolve, reject) => {
        return Axios({
            url: backend + 'bookings/lead-by-long-form-id/' + longFormId,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        }).then((data) => {
            resolve(data)
        }).catch(error => {
            reject(error)
        });
    });
}

export function ValidateDiscountCode(discount) {
    return new Promise((resolve, reject) => {
        return Axios({
            url: backend + 'bookings/validate-discount/' + discount,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        }).then((data) => {
            resolve(data.data)
        }).catch(error => {
            reject(error)
        });
    });
}

export function GetFranchiseByName(name, geo_target?) {
    return new Promise((resolve, reject) => {
        let url = backend + 'franchise/booking-form/location/' + name + '/';
        if (geo_target) {
            const encodedGeoTarget = encodeURIComponent(geo_target);
            url += `?google_search=${encodedGeoTarget}`;
        }

        return Axios({
            url: url,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        }).then((data) => {
            resolve(data.data);
        }).catch(error => {
            reject(error);
        });
    });
}



export function GetExemptDatesByLocation(location) {
    return new Promise((resolve, reject) => {
        return Axios({
            url: backend + 'bookings/get-exempt-booking-dates/' + location,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        }).then((data) => {
            resolve(data.data)
        }).catch(error => {
            reject(error)
        });
    });
}

export function SubmitLeadForm(lead: Lead, service, initial: boolean, facebook_data, gclid, msclkid, referralCode: string | null = null): Promise<any> {
    return new Promise((resolve, reject) => {
        return Axios({
            url: backend + 'bookings/lead-form/',
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: {
                lead: lead,
                service: service,
                initial: initial,
                facebook_data: facebook_data,
                gclid: gclid,
                msclkid: msclkid,
                referral_code: referralCode
            }
        }).then((data) => {
            resolve(data.data)
        }).catch(error => {
            reject(error)
        });
    });
}

export function SubmitCommercialLeadForm(formData) {
    return new Promise((resolve, reject) => {
        return Axios({
            url: backend + 'bookings/commercial-form/',
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: {
                company_name: formData.companyName,
                contact_name: formData.contactName,
                email: formData.email,
                phone: formData.phone,
                property_type: formData.propertyType,
                number_of_properties: formData.numberOfProperties,
                message: formData.message,
                submitted_at: new Date().toISOString()
            }
        }).then((data) => {
            resolve(data.data)
        }).catch(error => {
            reject(error)
        });
    });
}


export function SubmitBookingForm(lead: Lead, services, booking_time, discountCode, booked_from) {
    return new Promise((resolve, reject) => {
        return Axios({
            url: backend + 'bookings/booking-form/',
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: {
                lead: lead,
                services: services,
                booking_time: booking_time,
                discount_code: discountCode,
                booked_from: booked_from,
            }
        }).then((data) => {
            resolve(data.data)
        }).catch(error => {
            reject(error)
        });
    });
}


/** Insert the standard UK space before the inward code (last 3 characters). */
export function formatUkPostcode(postcode: string): string {
    const compact = postcode.trim().toUpperCase().replace(/\s+/g, "");
    if (compact.length < 5 || compact.length > 7) {
        return compact;
    }
    return `${compact.slice(0, -3)} ${compact.slice(-3)}`;
}

export function GetAddressFromPostcode(postcode: String) {
    const query = formatUkPostcode(postcode.toString());
    return new Promise((resolve, reject) => {
        return Axios({
            url: backend + 'bookings/address-autocomplete/?q=' + encodeURIComponent(query),
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        }).then((data) => {
            // Transform Ideal Postcodes response to match existing format
            const suggestions = data.data?.result?.hits?.map((s: any) => {
                // Remove the outward postcode from end of address (e.g., ", OL12" -> "")
                const address = s.suggestion?.replace(/,\s*[A-Z]{1,2}\d{1,2}[A-Z]?\s*$/, '') || s.suggestion;
                return {
                    address,
                    id: s.udprn?.toString() || s.id
                };
            }) || [];
            resolve({ suggestions });
        }).catch(error => {
            reject(error)
        });
    });
}

export function AskQuestion(question: String) {
    return new Promise((resolve, reject) => {
        return Axios({
            url: backend + 'marketing/ask-question/',
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: {
                question: question
            }
        }).then((data) => {
            resolve(data.data);
        }).catch(error => {
            reject(error);
        });
    });
}

export function GetJobPostings() {
    return new Promise((resolve, reject) => {
        return Axios({
            url: backend + 'careers/jobs/',
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        }).then((data) => {
            resolve(data.data)
        }).catch(error => {
            reject(error)
        });
    });
}

export function SubmitJobApplication(formData, facebook_data) {
    if (facebook_data) {
        formData.append('facebook_data', JSON.stringify(facebook_data));
    }

    return new Promise((resolve, reject) => {
        return Axios({
            url: backend + 'careers/apply/',
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: formData
        }).then((data) => {
            resolve(data.data)
        }).catch(error => {
            reject(error)
        });
    });
}